import React = require("react");
import Select from "react-select";
import { ready } from "../../../../custom_api/api_utils";
import { SearchOn } from "../../../../custom_api/collection/types";
import { Loader } from "../../loader";
import { customSelectStyles, customSelectTheme } from "../Shared/AsyncSelectStyles";
import { InspirationBaseSelector, inspirationLabelsWeb } from "../Shared/InspirationBaseSelector";
import { InspirationWrapper } from "../Shared/InspirationWrapperWeb";
import BookSlider from "./BookSlider";
import { ThemeBasedInspirationLayoutProps } from "./ThemeBasedInspirationState";
import { contentTexts } from "../Shared/InspirationUtils";

export const ThemeBasedInspirationLayoutWeb = (props: ThemeBasedInspirationLayoutProps) => {
  const { popularThemes, collectionPage, routePath, searchResults, searchQuery, pushDataLayer, updateSearchQuery, pickTheme } = props

  return (
    <div className="inspiration-page ip ip--theme-based-inspiration" key="ThemeBasedInspirationLayout">
      {collectionPage.kind != "loaded" ? <Loader /> :
        <InspirationWrapper 
          {...{ ...collectionPage.value, pageTitle: `${collectionPage.value.pageTitle} - Thema` }}
        >
          <div className={"ip__content"}>
            <div className="container--m">
              <h2 className="ip__title title--l">Inspiratie nodig?</h2>
              <p className="ip_description description--l">
                Heb je hulp nodig met het ontdekken van je volgende boek? Kijk dan hieronder.
                Klik op een boek dat je leuk lijkt en reserveer het direct bij jouw bibliotheek.
              </p>
              <InspirationBaseSelector activeBase="theme" routePath={routePath} labels={inspirationLabelsWeb} />
              <div className="searchbar--theme">
                  <div className="searchbar__inner">
                    <h2 className="searchbar__title">Zoek op een onderwerp naar keuze</h2>
                    <div className="searchbar__input">
                      <Select<SearchOn>
                        className="searchbar__select react-select"
                        classNamePrefix="react-select"
                        placeholder={contentTexts.theme.searchPlaceholder}
                        styles={customSelectStyles}
                        theme={(theme) => customSelectTheme(theme)}
                        noOptionsMessage={() => 'Geen suggesties gevonden.'}
                        isClearable={true}
                        onInputChange={updateSearchQuery}
                        onChange={pickTheme}
                        inputValue={searchQuery}
                        options={ready(searchResults) ? searchResults.value : []}
                        onMenuOpen={ () => {} }
                        onMenuClose={ () => {} }
                        value={undefined}
                      />
                    </div>
                  </div>
                </div>
              {popularThemes.kind != 'loaded' ? <Loader /> :
                <div className="layout">
                  <div className="layout__content">
                    <div className="layout__filter">
                      <BookSlider popularThemes={popularThemes.value} pushDataLayer={pushDataLayer} routePath={routePath} selectionPrompt="Of kies één van deze onderwerpen als startpunt" />
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </InspirationWrapper>
      }
    </div>)
}

